import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./HomePage.css";
import "./WalletModal.css";
import { useAuth } from "./AuthProvider";
import bingo5Img from "./assets/bingo5.jpg";
import bingo10Img from "./assets/bingo10.jpg";
import keno5Img from "./assets/keno5.jpg";
import emoji5Img from "./assets/emoji5.jpg";
import star3Img from "./assets/star3.jpg";
import homeImg from "./assets/home.jpg";
import DepositModal from "./DepositModal";
import WithdrawModal from "./WithdrawModal";
import telegramupApi from "./telegramupApi";

const RULES = [
  {
    icon: "🎱",
    title: "Bingo",
    points: [
      "5×5 card with free center space",
      "Win: any row, column, diagonal (X), or 4 corners",
      "Multiple players can win — prize split equally",
      "Numbers 1–75, stake 5 Birr",
    ],
  },
  {
    icon: "🔢",
    title: "Keno",
    points: [
      "Pick 3, 4, or 5 numbers from 1–80",
      "Win when all your numbers are called",
      "Multiple winners split the prize",
      "Stake 5 Birr",
    ],
  },
  {
    icon: "🍎",
    title: "Emoji",
    points: [
      "5×5 emoji card with free center space",
      "Win: any row, column, or diagonal",
      "34 emoji pool, stake 5 Birr",
    ],
  },
  {
    icon: "⭐",
    title: "Star",
    points: [
      "Single row of 6 emojis, no free space",
      "Win when all 6 emojis are called",
      "64 emoji pool, stake 3 Birr",
    ],
  },
  {
    icon: "💰",
    title: "Deposit & Withdrawal",
    points: [
      "Deposit via Telegram bot — tap Deposit",
      "Send money to merchant, paste SMS confirmation",
      "Withdrawal via Telegram bot — tap Withdraw",
      "Balance updates automatically",
    ],
  },
  {
    icon: "🤝",
    title: "Invite & Earn",
    points: [
      "Invite friends using your referral link",
      "Earn commission on player registration",
      "Earn commission on first 10 deposits",
      "Earn commission on player losses after that",
    ],
  },
];

export default function HomePage({ onGame }) {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [openRule, setOpenRule] = useState(null);
  const [rulesOpen, setRulesOpen] = useState(false);
  const [showDeposit, setShowDeposit] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);
  const [bonus, setBonus] = useState(null);
  const [bonusBusy, setBonusBusy] = useState(false);
  const [bonusMsg, setBonusMsg] = useState("");

  const loadBonus = () =>
    telegramupApi.getBonusStatus().then(setBonus).catch(() => setBonus(null));

  useEffect(() => {
    if (user?.telegram_id) loadBonus();
    // eslint-disable-next-line
  }, [user?.telegram_id]);

  const handleClaimBonus = async () => {
    setBonusBusy(true);
    setBonusMsg("");
    try {
      const res = await telegramupApi.claimBonus();
      setBonusMsg(`🎉 +${res.amount} Birr bonus added!`);
      refreshUser();
    } catch (err) {
      setBonusMsg(err.response?.data?.detail || "Could not claim bonus");
    } finally {
      setBonusBusy(false);
      loadBonus();
    }
  };

  const handleGameClick = (gameKey) => {
    try {
      const gameRoutes = {
        bingo_10: "/bingo-10",
        bingo_20: "/bingo-20",
        bingo_30: "/bingo-30",
        bingo_40: "/bingo-40",
        keno_5: "/keno-5",
      };

      const route = gameRoutes[gameKey];
      if (route) {
        // Pass telegram_id and username to Bingo games
        const urlParams = new URLSearchParams(window.location.search);
        const telegramId = urlParams.get("telegram_id") || user?.telegram_id;
        const username = urlParams.get("username") || user?.username || "User";

        if (telegramId) {
          navigate(`${route}?telegram_id=${telegramId}&username=${username}`);
        } else {
          navigate(route);
        }
      } else if (onGame) {
        onGame(gameKey);
      }
    } catch (err) {
      console.error("Game click error:", err);
      setError(`Error: ${err.message}`);
    }
  };

  const games = [
    { key: "keno_5",   img: keno5Img },
    { key: "bingo_20", img: bingo10Img },
    { key: "bingo_10", img: bingo5Img },
    { key: "bingo_40", img: star3Img },
    { key: "bingo_30", img: emoji5Img },
  ];

  const balance = parseFloat(user?.balance || 0).toFixed(2);
  const promoBalance = parseFloat(user?.promo_balance || 0);
  const [activeWallet, setActiveWallet] = useState(
    () => localStorage.getItem("activeWallet") || "real"
  );
  useEffect(() => {
    localStorage.setItem("activeWallet", activeWallet);
  }, [activeWallet]);
  useEffect(() => {
    if (promoBalance <= 0 && activeWallet === "promo") setActiveWallet("real");
  }, [promoBalance, activeWallet]);

  if (error) return <div className="page" style={{ padding: 20, color: "red" }}>{error}</div>;

  if (!user || !user.telegram_id) {
    return (
      <div className="landing">
        <img src={homeImg} alt="Lala Game" className="landing__img" />
        <a href="https://t.me/LalaGames_bot" className="landing__btn">
          <svg className="landing__tg-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"/>
          </svg>
          Play on Telegram
        </a>
        <p className="landing__footer">Play free games</p>
      </div>
    );
  }

  return (
    <div className="page">

      {/* ── Ticker banner ──────────────────────────── */}
      <div className="ticker">
        <div className="ticker__track">
          🎉 Welcome to Lala Game! &nbsp;•&nbsp; 🎱 Win big with Bingo! &nbsp;•&nbsp;
          💰 Deposit &amp; play now &nbsp;•&nbsp; 🏆 Daily jackpots available &nbsp;•&nbsp;
          🎉 Welcome to Lala Game! &nbsp;•&nbsp; 🎱 Win big with Bingo! &nbsp;•&nbsp;
          💰 Deposit &amp; play now &nbsp;•&nbsp; 🏆 Daily jackpots available
        </div>
      </div>

      {/* ── Header ─────────────────────────────────── */}
      <header className="header">
        <div className="header__info">
          <div className="avatar">{user?.username?.charAt(0).toUpperCase() || "U"}</div>
          <div>
            <p className="header__name">{user?.username || "User"}</p>
            <p className="header__id">ID: {user?.telegram_id || "Guest"}</p>
          </div>
        </div>
        <div className="wallet">
          <p className="wallet-choose">Choose</p>
          <div className="wallet__row">
            <div className="wallet__text">
              <p className="wallet__label">💳 Balance</p>
              <p className="wallet__balance">{balance} <span className="wallet__unit">Birr</span></p>
            </div>
            <button
              className={`wallet-toggle__btn${activeWallet === "real" ? " wallet-toggle__btn--active" : ""}`}
              onClick={() => setActiveWallet("real")}
            >
            </button>
          </div>
          <div className="wallet__row">
            <div className="wallet__text">
              <p className="wallet__label wallet__label--bonus">🎁 Bonus</p>
              <p className="wallet__balance wallet__balance--bonus">
                {promoBalance.toFixed(2)} <span className="wallet__unit">Birr</span>
              </p>
            </div>
            <button
              className={`wallet-toggle__btn${activeWallet === "promo" ? " wallet-toggle__btn--active" : ""}`}
              onClick={() => setActiveWallet("promo")}
            >
            </button>
          </div>
        </div>
      </header>

      {/* ── Phone row ──────────────────────────────── */}
      <div className="phone-row">
        <span className="phone-row__label">📱 Phone</span>
        <span className="phone-row__number">{user?.phone && user.phone !== "Not registered" ? user.phone : "09****"}</span>
      </div>

      {/* ── Deposit / Withdraw buttons ─────────────── */}
      <div className="wallet-actions">
        <button
          className="wallet-actions__btn"
          onClick={() => setShowDeposit(true)}
        >
          💰 Deposit
        </button>
        <button
          className="wallet-actions__btn wallet-actions__btn--withdraw"
          onClick={() => setShowWithdraw(true)}
        >
          🏦 Withdraw
        </button>
      </div>

      {/* ── Bonus ──────────────────────────────────── */}
      {bonus?.active && (
        <div className="wallet-actions wallet-actions--bonus">
          <button
            className="wallet-actions__btn wallet-actions__btn--bonus"
            onClick={handleClaimBonus}
            disabled={bonusBusy || !bonus.can_claim}
          >
            🎁 {bonus.can_claim ? `Claim ${bonus.amount} Birr Bonus` : "Bonus"} · {bonus.remaining_claims} left
          </button>
        </div>
      )}
      {(bonusMsg || (bonus?.active && !bonus.can_claim && bonus.reason)) && (
        <p className="bonus-msg">{bonusMsg || bonus.reason}</p>
      )}

      {/* ── Game cards ─────────────────────────────── */}
      <main className="games">
        <p className="games__title">🎮 Choose a Game</p>
        <div className="games__grid">
          {games.map((g) => (
            <button key={g.key} className="game-card" onClick={() => handleGameClick(g.key)}>
              <img src={g.img} alt={g.key} className="game-card__img" />
            </button>
          ))}
        </div>
      </main>

      {/* ── LALA Game banner ──────────────────────── */}
      <div className="lala-banner">
        <div className="lala-banner__inner">
          <span className="lala-banner__icon">🎰</span>
          <h2 className="lala-banner__title">LALA Game</h2>
          <span className="lala-banner__icon">🎰</span>
        </div>
        <p className="lala-banner__tagline">Play • Win • Celebrate</p>
        <div className="lala-banner__shine" />
      </div>

      {/* ── Rules & Info ────────────────────────────── */}
      <section className="rules">
        <button className="rules__header" onClick={() => setRulesOpen(!rulesOpen)}>
          <span className="rules__title-text">📋 Rules & Info</span>
          <span className={`rules__arrow ${rulesOpen ? "rules__arrow--open" : ""}`}>›</span>
        </button>
        {rulesOpen && (
          <div className="rules__list">
            {RULES.map((rule, i) => (
              <div key={i} className="rules__item">
                <button
                  className="rules__btn"
                  onClick={() => setOpenRule(openRule === i ? null : i)}
                >
                  <span className="rules__icon">{rule.icon}</span>
                  <span className="rules__label">{rule.title}</span>
                  <span className={`rules__arrow ${openRule === i ? "rules__arrow--open" : ""}`}>›</span>
                </button>
                {openRule === i && (
                  <ul className="rules__points">
                    {rule.points.map((pt, j) => (
                      <li key={j} className="rules__point">{pt}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        )}
      </section>

      {/* ── Modals ─────────────────────────────────── */}
      {showDeposit && (
        <DepositModal
          onClose={() => setShowDeposit(false)}
          onSuccess={refreshUser}
        />
      )}
      {showWithdraw && (
        <WithdrawModal
          balance={balance}
          promoBalance={promoBalance}
          onClose={() => setShowWithdraw(false)}
          onSuccess={refreshUser}
        />
      )}

    </div>
  );
}
